<template>
    <main id="home-slider-component">
        <section class="top-banner">

            <div v-if="typeof loadingContent != 'undefined' && loadingContent" class="container slider-default-loader">    
                <content-loader
                    width="1490"
                    height="475"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb">
                    <rect x="448" y="30" rx="0" ry="0" width="750" height="300" />
                    <rect x="239" y="53" rx="0" ry="0" width="643" height="254" />
                    <rect x="30" y="76" rx="0" ry="0" width="527" height="208" />
                    <rect x="762" y="53" rx="0" ry="0" width="643" height="254" />
                    <rect x="1087" y="76" rx="0" ry="0" width="527" height="208" />
                </content-loader>
            </div>
            <template v-else >
                <slick   :key="filteredBanners.length + location_city"  ref="slick" :options="slickOptions" v-animate-css="animate.fadeIn">
                    <template v-if="defaultPageData">
                      <div v-for="(banner, index) in filteredBanners" :key="index" class="silk-item">
                        <a v-if="banner.link" :href="banner.link" target="_blank">
                          <img :src="banner.image" :alt="banner.title" />
                        </a>
                        <a v-else href="javascript:void(0)">
                          <img :src="banner.image" :alt="banner.title" />
                        </a>
                      </div>
                    </template>
                    <template v-else>
                        <div class="silk-item"><img :src="'/banners/new-banner-2.jpg'| assetPath" alt=""/></div>
                    </template>  
                </slick>
            </template>
        </section>
    </main>
</template>

<script>

    import helpers from './../../mixin/helpers';
    import { ContentLoader } from 'vue-content-loader'
    import {bus} from '../../app';

    import carousel from 'vue-owl-carousel2'
    import Slick from 'vue-slick';
    import { mapFields } from "vuex-map-fields";
    import 'slick-carousel/slick/slick.css';
    import 'slick-carousel/slick/slick-theme.css'
    export default {
        data() {
            return {
                loadingContent: false,
                     location_city:'',
                banners: [],
                leaderSpeed:1,
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight,
                slickOptions: {
                    autoplay:true,
                    slidesToShow: 1,
                    arrows: true,
                    dots: false,
                    slide:'div',
                    // centerPadding:50,
                    lazyLoad:true,
                    // Any other options that can be got from plugin documentation
                    responsive: [{

                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            infinite: true
                        }

                    }, {

                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            dots: false,
                            arrows: true
                        }

                    }, {

                        breakpoint: 300,
                        settings: "unslick" // destroys slick

                    }]
                },
            }
        },
        mixins: [helpers],
        components: {
            Slick,
            carousel,
            ContentLoader
        },
        watch: {
  defaultPageData(newVal) {
    if (newVal) {
      this.refreshSlick();
    }
  },
  location_city(newVal) {
    if (newVal) {
      this.refreshSlick();
    }
  }
},
        beforeCreate() {
            console.log('===== Slick Before Create=====');
            this.loadingContent = true;
        },
        created() {
            console.log('===== Slick Created =====');
            this.loadingContent = false;
                 bus.$on('updateLocation', () => {
                const location = this.$session.get('default_location');
                this.location_city = typeof location === 'object' ? location.name : location;
                console.log('Updated location:', this.location_city);
                });

        },
        destroyed() {
            // window.removeEventListener("resize", this.myEventHandler);
            console.log('===== Slick Destroyed =====');
        },
        updated() {
            // this.reInit();
            console.log('===== Slick Updated =====');
        },
        computed: {
  ...mapFields([
    "defaultPageData"
  ]),

//   canShowBanners() {
//     console.log('canShowBanners checked:', {
//       location_city: this.location_city,
//       defaultPageData: this.defaultPageData
//     });
//     return this.defaultPageData && this.defaultPageData.banners && this.location_city;
//   },



  filteredBanners() {
  if (!this.defaultPageData || !this.defaultPageData.banners) return [];

  const currentCity = this.location_city;
  console.log('Filtering banners for city:', currentCity);

  // Remove duplicates by banner.id
  const uniqueBanners = this.defaultPageData.banners.reduce((acc, banner) => {
    if (!acc.some(b => b.id === banner.id)) {
      acc.push(banner);
    }
    return acc;
  }, []);

  // Banners for current city
  const cityBanners = uniqueBanners.filter(banner =>
    banner.cities && banner.cities.some(city => city.name === currentCity)
  );

  // Banners for "All Cities" (not already included)
  const allCitiesBanners = uniqueBanners.filter(banner =>
    banner.cities && banner.cities.some(city => city.name === 'All Cities') &&
    !cityBanners.some(b => b.id === banner.id)
  );

  // Banners without any cities assigned
  const noCitiesBanners = uniqueBanners.filter(banner =>
    !banner.cities || banner.cities.length === 0
  );

  // Combine in required order
  const result = [...cityBanners, ...allCitiesBanners, ...noCitiesBanners];

  console.log('Filtered banners:', {
    cityBanners: cityBanners.map(b => b.title),
    allCitiesBanners: allCitiesBanners.map(b => b.title),
    noCitiesBanners: noCitiesBanners.map(b => b.title),
    result: result.map(b => b.title)
  });

  return result;
}



},
mounted() {
  window.addEventListener('resize', this.myEventHandler);

  let location = this.$session.get('default_location');

  if (!location) {
    let sessionData = localStorage.getItem('vue-session-key');
    sessionData = sessionData ? JSON.parse(sessionData) : null;
    if (sessionData && sessionData.default_location) {
      location = sessionData.default_location;
    }
  }

  this.location_city = typeof location === 'object' ? location.name : location;
  console.log('Initial location:', this.location_city);

  this.getBanners();

  this.$nextTick(() => {
    if (this.$refs.slick) {
      this.$refs.slick.destroy();
      this.$refs.slick.create();
    }
  });
},


        unmounted() {
            window.removeEventListener('resize', this.myEventHandler);
            console.log('===== Slick Mounted =====');
        },
        methods: {
            refreshSlick() {
    this.$nextTick(() => {
      if (this.$refs.slick) {
        this.$refs.slick.destroy();
        this.$refs.slick.create();
      }
    });
  },
            myEventHandler(e) {
                console.log('===== Slick myEventHandler =====',e);
                // setTimeout(() => {
                    this.reInit(this.slickOptions);    
                // }, 500);
            },
            getBanners:function (){
                var vm = this;
                axios.get("data/banners",{ params: {
                  'slot': 'home'
                }}).then(response => {
                    vm.banners = response.data.data;
                    vm.loadingContent = false;
                }).catch(function (errors) {
                    vm.loadingContent = false;
                });

            },
            next() {
                this.$refs.slick.next();
            },

            prev() {
                this.$refs.slick.prev();
            },
            reInit() {
                console.log('Helpful if you have to deal with v-for to update dynamic lists');
                // Helpful if you have to deal with v-for to update dynamic lists
                this.$nextTick(() => {
                    this.$refs.slick.reSlick(this.slickOptions);
                });
            },
        },
        filters: {
            checkNullLink: function (link) {
                var checklink = link? link:'javascript:void(0);';
                return checklink;
            },
        }
    }
</script>


<style>
    /* .owl-nav disabled {
        margin-bottom: 369px;
    } */
</style>